export const ROWS_PER_PAGE: number = 25;
export const ROWS_PER_PAGE_OPTIONS: Array<number> = [ROWS_PER_PAGE, 50, 100, 500];
